
import { motion } from 'framer-motion';

export function Location() {
  const benefits = [
    {
      icon: 'ri-school-line',
      title: '안심 교육환경',
      description: '단지 앞 새동초·중학교(26년 3월 개교예정), 유치원(예정부지)'
    },
    {
      icon: 'ri-subway-line',
      title: '수도권 접근성',
      description: '화성시청역(서해선 복선전철), 신안산선(연장예정)'
    },
    {
      icon: 'ri-road-map-line',
      title: '사통팔달 교통망',
      description: '수도권제2순환고속도로, 서해안고속도로, 77번 국도'
    },
    {
      icon: 'ri-building-2-line',
      title: '생활인프라',
      description: '화성시청, 상업시설, 업무시설 등 갖춰진 편의시설'
    },
    {
      icon: 'ri-briefcase-line',
      title: '직주근접',
      description: '인근 산업단지, 관공서로 출·퇴근이 편리한 단지'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '합리적 분양가',
      description: '선호도 높은 전용면적 84㎡ 4억원 대 분양가상한제'
    }
  ];

  const locationImages = [
    {
      src: 'https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/0272ee50f1d1285b8e2a27e00bd368be.png',
      alt: '교통망 지도'
    },
    {
      src: 'https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/50f4856f8d413f848acd987a13d84b1e.png',
      alt: '도시 전경'
    },
    {
      src: 'https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/27dedf6c2fec3694a1f9ee649d9f5459.png',
      alt: '주변 인프라'
    }
  ];

  return (
    <section id="location" className="py-12 sm:py-16 md:py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-[1800px] mx-auto px-4 sm:px-6">
        {/* Mobile Header */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-6 sm:mb-8 lg:hidden"
        >
          <div className="flex items-center gap-2 mb-4 sm:mb-6">
            <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
            <p className="text-amber-600 text-xs sm:text-sm font-semibold tracking-wider uppercase">
              LOCATION PREMIUM
            </p>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            사통팔달 교통망과<br />
            완벽한 생활 인프라
          </h2>
        </motion.div>

        {/* Benefits Grid - Mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8 lg:hidden">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05, duration: 0.6 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-5 hover:bg-amber-600 hover:border-amber-600 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                  <i className={`${benefit.icon} text-2xl sm:text-3xl text-amber-600 group-hover:text-white transition-colors`}></i>
                </div>
                <div>
                  <h3 className="text-sm sm:text-base font-bold mb-1 group-hover:text-white">
                    {benefit.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-300 group-hover:text-white/90 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Images - Mobile */}
        <div className="space-y-4 lg:hidden">
          {locationImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 + index * 0.1, duration: 0.6 }}
              className="rounded-xl sm:rounded-2xl overflow-hidden shadow-xl"
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover"
              />
            </motion.div>
          ))}
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:grid grid-cols-[3fr_2fr] gap-12 items-start">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
              <p className="text-amber-600 text-sm font-semibold tracking-wider uppercase">
                LOCATION PREMIUM
              </p>
            </div>
            <h2 className="text-5xl font-bold mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              사통팔달 교통망과<br />
              완벽한 생활 인프라
            </h2>
            
            {/* Image Gallery */}
            <div className="space-y-4">
              {/* Main Image */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="rounded-2xl overflow-hidden shadow-2xl"
              >
                <img
                  src={locationImages[0].src}
                  alt={locationImages[0].alt}
                  className="w-full h-[700px] object-cover"
                />
              </motion.div>
              
              {/* Two Additional Images */}
              <div className="flex flex-col gap-4">
                {locationImages.slice(1).map((image, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 + index * 0.1, duration: 0.6 }}
                    className="rounded-2xl overflow-hidden shadow-xl"
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-[538px] object-cover hover:scale-105 transition-transform duration-500"
                    />
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Right Content - Benefits Grid */}
          <div className="grid grid-cols-1 gap-5 sticky top-24">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 hover:bg-amber-600 hover:border-amber-600 transition-all duration-300 group cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                    <i className={`${benefit.icon} text-3xl text-amber-600 group-hover:text-white transition-colors`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-bold mb-1 group-hover:text-white">
                      {benefit.title}
                    </h3>
                    <p className="text-sm text-gray-300 group-hover:text-white/90 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
